module.exports = __webpack_public_path__ + "performance.P_JIueW-.svg";